<template>
  <div>
    <va-modal
      class="evollu-form"
      :value="showModal"
      id="createContactBlockModal"
      ref="createContactBlockModal"
      size="large"
      :showOkay="true"
      :okText="this.$t('iframe.titles.create_block')"
      :cancelText="$t('leads.back')"
      @cancel="$emit('cancel')"
      @ok="handleSubmit"
      :ok-disabled="!canSubmit"
      :noOutsideDismiss="true">

      <div slot="header" class="d-flex justify--space-between">
        <span>
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ this.$t('iframe.titles.create_block')}}</b></span>
        </span>
      </div>

      <BlockDetails
        :form-errors="blockErrors"
        v-model="blockForm"
        ref="blockDetails"
        :clientOptions="clientOptions"
      />
    </va-modal>
  </div>
</template>

<script>
import BlockDetails from "@/components/iframe/blocks-builder/contact/BlockDetails";
import {IframeService} from "@/api/IframeService";
import Errors from '@/utils/StandardErrors.js'
const errorsPrefix = 'iframe.blocks_builder.contact_block.errors.'
export default {
  components: {BlockDetails},
  data() {
    return {
      showModal: false,
      isSubmiting: false,
      blockForm:{
        name: null,
        lang: null,
        title: null,
        subtitle: null,
        consent_options: false,
        override_button_previous_title: null,
        override_button_previous_action: null,
        fields: [],
        client: null,
      },
      blockErrors: new Errors()
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    handleSubmit: function() {
      if(this.canSubmit) {
        this.isSubmiting = true
        let data = {...this.blockForm}
        data.fields = []
        data.fields = this.$refs.blockDetails.getAddedItems()
        if (this.blockForm.lang !== null) {
          data.lang = this.blockForm.lang.lang
        }
        if(this.blockForm.client) {
          data.client_id = this.blockForm.client.id
        }
        IframeService.createContactPage(data)
          .then(res => {
            this.showToast(this.$t('iframe.blocks_builder.created'), this.$store.state.successToastOptions)
            this.$emit('created' )
            this.showModal = false
          })
          .catch(errors => {
            console.log(errors)
            if(errors.response.status === 422) {
              this.blockErrors.record(errors.response.data.errors, errorsPrefix)
              this.showToast(this.$t('iframe.blocks_builder.create_error'), this.$store.state.errorToastOptions)
            }else {
              this.showToast(this.$t('iframe.blocks_builder.create_error'), this.$store.state.errorToastOptions)
            }
          })
          .finally(() => {
            this.isSubmiting = false
          })
      }
    }
  },
  computed: {
    canSubmit() {
      return (this.blockForm.name !== null && this.blockForm.name !== '') && !this.isSubmiting && this.blockForm.client !== null
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          if(this.iframeService.entities.length === 1) {
            this.blockForm.client = this.iframeService.entities[0]
          }
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        const consideredEntities = this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
        if (consideredEntities.length === 1) {
          this.blockForm.client = consideredEntities[0]
        }
        return consideredEntities
      }
      return []
    },
  }

}
</script>

<style scoped>

</style>
